import React from 'react';
import MediaPlayer from '../../videochat/components/MediaPlayer';

const FloatingVideoChatWindow = ({ 
  localTrack, 
  remoteUsers, 
  onMaximize, 
  onClose 
}) => {
  return (
    <div className="floating-video-chat">
      <div className="floating-video-content">
        {localTrack && (
          <MediaPlayer 
            videoTrack={localTrack} 
            local={true}
            width={"275px"}
            height={"19vh"}
            minimized={true}
          />
        )}
      </div>
      <div className="floating-controls">
        <button onClick={onMaximize}>
          <i className="fas fa-expand"></i>
        </button>
        <button onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default FloatingVideoChatWindow;
